import { slotThreadKey } from "@/lib/targeting/slot-thread";
import type { ThreadListItem } from "@/lib/widget-thread";

/**
 * Demo / playground (no BE) with message slots: the slot threads the visitor has talked in are ADDED to
 * the bundled demo threads (the Gaia conversation stays reachable from the list); they do not replace them.
 */
export function withDemoSlotThreads(
  demoThreads: ThreadListItem[],
  opened: Record<string, { title: string; at: string }>,
  senderName: string,
): ThreadListItem[] {
  const slotRows = Object.entries(opened).map(
    ([slotId, t]): ThreadListItem => ({
      chatId: `demo-${slotThreadKey(slotId)}`,
      threadKey: slotThreadKey(slotId),
      title: t.title,
      status: "OPEN",
      unreadCount: 0,
      updatedAt: t.at,
      preview: null,
      senderName,
      lastSenderKind: "ai",
    }),
  );
  return [...demoThreads, ...slotRows];
}
